/**
 * URL Parameter Parser
 * Extracts feature flags from URL query parameters
 */

import { FeatureFlag } from './types';
import { DEFAULT_CONFIG } from './constants';

export function parseUrlFlags(
  urlPrefix: string = DEFAULT_CONFIG.urlPrefix
): Record<string, FeatureFlag> {
  const flags: Record<string, FeatureFlag> = {};
  
  if (typeof window === 'undefined') {
    return flags;
  }

  const params = new URLSearchParams(window.location.search);
  
  params.forEach((value, key) => {
    if (key.startsWith(urlPrefix)) {
      const flagName = key.substring(urlPrefix.length);
      
      flags[flagName] = {
        name: flagName,
        enabled: parseValue(value),
      };
    }
  });

  return flags;
}

function parseValue(value: string): boolean {
  const lowercaseValue = value.toLowerCase();
  return lowercaseValue === 'true' || lowercaseValue === '1' || lowercaseValue === 'on';
}

export function buildUrlWithFlags(
  flags: Record<string, boolean>,
  urlPrefix: string = DEFAULT_CONFIG.urlPrefix
): string {
  const url = new URL(window.location.href);
  
  Object.entries(flags).forEach(([key, value]) => {
    const paramKey = `${urlPrefix}${key}`;
    if (value) {
      url.searchParams.set(paramKey, 'true');
    } else {
      url.searchParams.delete(paramKey);
    }
  });
  
  return url.toString();
}
